import React from 'react';
import { Form, Input } from 'antd';
import SectionHeader from '../../components/SectionHeader';
import YesNoToggle from '../../components/YesNoToggle';
import AddressBlock from '../../components/AddressBlock';
import { billingAddressSummary } from '../../utils';
import s from '../../s.module.less';
import sc from './s.module.less';

const CheckFilledIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
        <circle cx="12" cy="12" r="10" fill="#22C55E" />
        <path d="m8 12 2.6 2.6L16 9" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// Step 4 — Service location：是否与账单地址相同；no 时展开 facility name + 完整地址块
export default function StepServiceLocation() {
    const form = Form.useFormInstance();
    const sameAsBilling = Form.useWatch(['location', 'sameAsBilling'], form);
    // 跨步骤取值须用 getFieldsValue(true)：useWatch 初始值只统计已挂载字段，别的步骤卸载后读不到；
    // useWatch 仅用于 address 字段同屏（review 内联编辑）变化时触发重渲染
    Form.useWatch(['address'], form);
    const billingAddress = form.getFieldsValue(true)?.address;

    return (
        <div className={s.wizSection} data-wiz-section>
            <SectionHeader title="Where you see patients" />
            <Form.Item name={['location', 'sameAsBilling']} label="Same as billing address?">
                <YesNoToggle yesLabel="Yes, same address" noLabel="No, different location" />
            </Form.Item>
            {sameAsBilling === 'yes' && (
                <div className={sc.addrConfirm}>
                    <CheckFilledIcon />
                    <span>{billingAddressSummary(billingAddress)}</span>
                </div>
            )}
            {sameAsBilling === 'no' && (
                <>
                    <Form.Item name={['location', 'facilityName']} label="Facility name">
                        <Input size="large" placeholder="Facility name" />
                    </Form.Item>
                    <AddressBlock ns={['location']} />
                </>
            )}
        </div>
    );
}
